<script setup lang="ts">
// hooks
import { useStrapiSiteHeader } from '@api/strapi/site-header/strapi-site-header.hook'
// components
import SiteHeader from '@Widgets/Headers/SiteHeader.vue'

defineOptions({
  name: 'SiteHeaderContainer',
})

const { refSiteHeader } = await useStrapiSiteHeader()
</script>

<template>
  <SiteHeader
    v-if="refSiteHeader"
    :data="refSiteHeader"
  />
</template>
